import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Employee } from "entitites/employees/model/employee";
import { StatusChip } from "shared";

export const AccountsBodyView = ({ employee }: { employee: Employee }) => {
  return (
    <Box width="100%" display="flex" gap={0.25} flexDirection="column">
      {employee.accountsInfo.status && (
        <Box
          display="flex"
          alignItems="center"
          fontWeight={600}
          width="100%"
          gap={3}
        >
          <StatusChip
            title={employee.accountsInfo.status}
            color={
              employee.accountsInfo.status === "Нужно сделать"
                ? "#787977"
                : employee.accountsInfo.status === "В работе"
                ? "#CFA100"
                : "#88E181"
            }
          />

          <Typography minWidth={255} maxWidth={255} noWrap fontWeight={600}>
            {employee.accountsInfo.appl}
          </Typography>
        </Box>
      )}
      {employee.accountsInfo.accounts.map((field) => (
        <Box
          key={field.id}
          display="flex"
          alignItems="center"
          fontWeight={600}
          width="100%"
        >
          <Typography minWidth={255} maxWidth={255} noWrap fontWeight={600}>
            {field.label}
          </Typography>
          <Typography sx={{ ml: "auto", width: 300 }}>{field.value}</Typography>
        </Box>
      ))}
    </Box>
  );
};
